<template>
  <el-drawer
    title="企业服务协议"
    :visible.sync="enterpriseServiceVisible"
    direction="rtl"
    size="70%"
    @close="enterpriseServiceVisibleClose"
  >
    <div class="box">
      <p class="tAlign">“WoYou工资”企业版服务协议</p>
      <p class="tRight">生效日期: 2023年09月15日</p>
      <p class="tRight">发布日期：2023年9月15日</p>
      <p>“WoYou工资”企业版服务协议</p>
      <p>版本号：2.0</p>
      <p>欢迎您使用“WoYou工资”企业服务！</p>
      <p>
        为使用“WoYou工资”企业服务（或称“乙方”），您（或称“甲方”）应当仔细阅读并遵守本服务协议下的全部内容，特别是涉及免除或者责任限制的条款，该类条款可能以黑体加粗或加下划线的形式提示您重点注意。除非您已阅读并接受本服务协议所有条款，否则您将不能使用“WoYou工资”企业服务，如您不同意本服务条款的任意内容，请勿注册或使用“WoYou工资”企业服务。如您对本服务协议的内容有任何疑义，可随时按照本服务协议中列明的联系方式与我们联系，我们将根据您的要求为您进一步解释和说明相关内容。如您作为“WoYou工资”企业服务的注册公司或者合作公司的用户登录“WoYou工资”企业服务平台，并勾选“我同意《服务协议》”，即视为您已阅读并同意本服务协议，自愿接受本服务协议的所有内容的约束。
      </p>
      <p>一、定义</p>
      <p>
        1.乙方平台：平台名称为“WoYou工资”企业服务”，是乙方现在或将来拥有合格权限运营/管理的，为合作企业用户提供信息展示、预订及交易等技术服务的网络服务平台，包括但不限于“WoYou工资”网、乙方关联方、乙方合作方运营/管理的网络服务平台，及未来可能新设或合作的网络平台。合作过程中，乙方平台名称存在变更的可能，若乙方平台名称发生变更，乙方应告知甲方，甲乙双方按原有协议继续执行。
      </p>
      <p>
        2.乙方商户/服务商：指根据乙方平台规则入驻乙方平台并向甲方用户提供最终合作产品/服务的商家/服务商。
      </p>
      <p>
        3.甲方用户/用户：甲方许可并授权通过本协议双方确认方式完成购买/预订合作产品/服务的甲方员工及关联企业。
      </p>
      <p>
        4.合作产品/服务：乙方基于本协议向甲方推送或展示本协议合作的产品/服务。
      </p>
      <p>
        5.乙方平台规则：乙方平台现有的或未来不时更新并向甲方推送或展示的平台、技术服务内容、技术服务规则、合作产品/服务预订规则
        、退改规则 、客服标准、公告等所有信息。
      </p>
      <p>6.预订：用户通过乙方平台进行在线预订的行为。</p>
      <p>7.消费金额：用户通过乙方平台预订产品所产生的消费金额。</p>
      <p>
        8.平台服务费：乙方为甲方提供的产品/技术服务，甲方应向乙方支付的服务费。
      </p>
      <p>二、账号安全及管理</p>
      <p>
        1.乙方根据甲方在“WoYou工资”企业服务账号和密码、员工信息等确认甲方身份。鉴于网络服务的特殊性，“WoYou工资”企业服务无义务审核是否是您本人使用该组用户名及密码，仅审核用户名等信息是否与数据库中保存的一致。任何人只要输入的用户名及密码与数据库中保存的一致，即可凭借该组用户名及密码登陆并使用“WoYou工资”企业服务所提供的各类服务，所以即使您认为您的账户登陆行为并非您本人所为，“WoYou工资”企业服务将不承担因此而产生的任何责任。
      </p>
      <p>
        2.甲方理解并确认通过甲方账号和密码进行的任何操作（包括但不限于在线点击确认协议、确认员工身份、在线下单等）均属于甲方的行为，并对其使用承担全部责任。除非有法律规定或司法裁定，且征得乙方的同意，否则，甲方的账号和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。
      </p>
      <p>三、服务内容</p>
      <p>
        1.“WoYou工资”企业服务可向您提供包含但不限于工资计算、工资直发、开卡、及其他约定的商务消费相关咨询、预订及管理服务（依据您的选择确定具体服务内容），为了满足甲方及甲方用户/员工需要，甲方可以委托乙方代向实际提供产品/服务的供应商或者商家购买产品/服务。乙方在代购情形下仅作为甲方的受托人，根据甲方要求代甲方向商家购买产品/服务，该等产品/服务均不由乙方直接出售/提供。
      </p>
      <p>
        2.乙方为甲方提供的丰富消费场景及服务包括但不限于以下内容中一种或多种：
      </p>
      <p>
        （1）企业消费的管理与分析，包括但不限于组织架构配置、权限配置、审批配置、消费规则设置、提醒事项、报表分析、订单和账单查询等；
      </p>
      <p>（2）对公付款业务；</p>
      <p>（3）其他企业消费相关的服务</p>
      <p>四、责任义务</p>
      <p>
        1.您同意：⑴提供及时、详尽及准确的个人资料。⑵不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。另外，您授权“WoYou工资”企业服务可以向第三方透露其基本资料用于必要服务，但我们不会公开您的补充资料。除非：⑴您要求透露这些信息。⑵相应的法律要求及程序要求提供您的个人资料。
      </p>
      <p>
        2.作为企业员工，您应当按照您所在公司的规则、要求（如可以下单的地址范围、时间范围、额度范围等）、“WoYou工资”商业服务的相关规则及要求使用“WoYou工资”商业服务，不得恶意使用“WoYou工资”企业服务平台系统违规操作、非法牟利，否则给您所在的企业或“WoYou工资”企业服务造成损失，您所在的企业或“WoYou工资”企业服务均可以要求您按照获利价值的10倍承担违约责任，违约责任不足弥补损失的，您还应另行足额赔偿，同时“WoYou工资”企业服务保留结束您使用“WoYou工资”企业服务服务的权利。
      </p>
      <p>
        3.“WoYou工资”企业服务提供服务的义务取决于银行、保险公司、保险经纪公司等产品服务的可供性，而所有这些又取决于价格，限制条件或者其他服务供应商的相关条款和条件，受服务供应商客观情况限制，乙方无法承诺百分之百都能预订或服务成功，对此您应予以理解。
      </p>
      <p>
        4.“WoYou工资”企业服务为您提供企业服务并不直接拥有或经营银行、保险、金融机构或者其他运输或与之有关的服务产品，因此您在使用中如果发生损失应由相关服务产品商家或供应商承担责任，但“WoYou工资”企业服务承诺将尽力协助您与相关服务商家或供应商进行协调。
      </p>
      <p>
        5.由于您原因，导致其他公司或个人在“WoYou工资”企业服务使用您相关账号进行预订的订单，您对此类订单的账款承担连带责任。
      </p>
      <p>
        6.您在享受“WoYou工资”企业服务提供的各项服务的同时，授权并同意接受“WoYou工资”企业服务向您的电子邮件、手机、通信地址等发送商业信息，包括不限于最新的产品信息、促销信息等。若您选择不接受“WoYou工资”企业服务提供的各类信息服务，您可以按照“WoYou工资”企业服务提供的相应设置拒绝该类信息服务。
      </p>
      <p>
        7.您应对企业用户进行日常维护及管理，包括但不限于及时在企业账号项下添加/更新/删除用户信息；用户消费行为的管理及合规；用户消费额度的授权；乙方平台规则的宣导；用户咨询及投诉的处理。如因您的原因导致您的用户投诉未能有效解决，因此造成损失的应由您承担相应赔偿责任，同时视前述情形的严重程度，“WoYou工资”企业服务有权选择单方终止本协议。
      </p>
      <p>
        8.为保证您的用户可以正常使用“WoYou工资”企业服务，您保证按照“WoYou工资”企业服务现有或不时更新的规则要求将用户需求、用户信息通过双方确认的方式传输给“WoYou工资”企业服务，并应保证其已获得用户的书面同意（包括但不限于书面确认、邮件、微信、系统或其他电子形式确认）或在不违反法律法规允许的情形下将相关数据提供给“WoYou工资”企业服务。如因您未履行前述义务，或因您的其他原因造成您的用户投诉的，由您负责直接处理，同时应承担用户及“WoYou工资”企业服务因此遭受的损失。
      </p>
      <p>
        9.如参与本协议执行的您的关联公司未按照本合同约定支付相关费用及履行相关义务，发生相关欠款时，您对其关联公司的欠款（包括但不限于票款及滞纳金）承担连带责任，“WoYou工资”企业服务有权直接向甲方追偿。
      </p>
      <p>
        10.瑞启应负责对““WoYou工资”企业服务”平台的日常运营和维护，有权对““WoYou工资”企业服务”平台进行升级、改造，若因系统升级须暂时中止提供““WoYou工资”企业服务”服务的，应提前7日告知您，并预告恢复日期。
      </p>
      <p>
        11.瑞启应保证““WoYou工资”企业服务“平台发布的内容符合相关法律、法规、规章及有关政策，不违反公序良俗，且不侵犯任何第三方的合法权益。否则因此发生的侵犯第三方合法权益或行政处罚的，由企业服务处理并承担相应的经济及法律责任。
      </p>
      <p>
        12.“WoYou工资”企业服务基于风险管理、运营管理或其他因素的考虑（包括但不限于有关部门监管要求、税收政策调整、不可抗力原因等），可以提前30日书面形式告知您终止本合同或暂停、中断提供本合同下的服务，或将本合同项下的权利或义务转让给其关联企业。“WoYou工资”企业服务确保其关联企业继续按照本合同的约定履行相关义务并向您提供有关服务，您已有权益不受减损。
      </p>
      <p>五、服务条款的修改</p>
      <p>
        “WoYou工资”企业服务会在必要时修改服务条款，如制订、修改本协议或各类规则向您提供基于互联网以及移动网的相关服务的，应在本页面及其相应页面提前公布通知，您应该定期登录本页面及其他相关页面，了解最新的协议内容。变更后的协议和规则在本页面及相关页面公布后七天，将自动生效。如您不同意相关变更，应当立即停止访问“WoYou工资”企业服务或使用“WoYou工资”企业服务服务，若您在网站协议和规则变更七日后继续使用“WoYou工资”企业服务的，即表示您接受已经修订的协议和规则。
      </p>
      <p>六、服务变更、中断、终止</p>
      <p>
        1.您完全理解并同意，本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此任何因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、GSM网络、互联网络、通信线路等其他“WoYou工资”企业服务无法预测或控制的原因，造成服务中断、取消或终止的风险，由此给您带来的损失“WoYou工资”企业服务不承担赔偿责任。
      </p>
      <p>
        2.“WoYou工资”企业服务需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，“WoYou工资”企业服务无需为此承担任何责任，但“WoYou工资”企业服务应尽可能事先进行通知。
      </p>
      <p>
        3.您完全理解并同意，除本服务协议另有规定外，鉴于网络服务的特殊性，“WoYou工资”企业服务有可能变更、中断或终止部分或全部的网络服务，您确认“WoYou工资”企业服务无需为此承担任何责任，但“WoYou工资”企业服务应尽可能事先进行通知，并尽可能给您预留时间以便处理相关权益。
      </p>
      <p>七、保密条款</p>
      <p>
        1.甲方充分知悉且理解乙方提供的产品/技术服务，为履行本协议项下服务，乙方在提供相应服务过程中不可避免的获取、解析、保存、更改、使用、传输、删除等方式（以下统称“处理”）个人数据。甲方对此知悉并确认：乙方有权对甲方提供的信息进行整理、分析，并将有服务需求人员的必要个人信息提供给实际终端服务商及中间所涉及的供应商（如航空公司及机票供应商、酒店及酒店供应商、机场、铁路、网约车平台、保险机构等）。
      </p>
      <p>
        2.甲乙双方均应对合作内容、业务数据、商业秘密、客户信息、本协议及与协议有关的计划和项目书等所有信息和经声明的保密资料负永久保密义务，不得提供、泄露上述内容予任何第三方（如因遵守法律法规规定或有权机关的要求而进行披露的除外），亦不得使用相关资料用于本合作项目以外的任何用途。如有违反本条约定，由违约方承担由此造成的全部损失。
      </p>
      <p>
        3.甲方同意，尽管前款规定，乙方可向其职员、顾问及供应商透露上述内容，前提是该种透露应为乙方履行本协议之义务所必需，且上述职员、顾问及供应商同意承担与本协议中所规定的保密义务相同或更严格的保密义务。
      </p>
      <p>
        4.协议任何一方若得知所保管的另一方的任何保密信息已经被第三方获得，则应及时通知对方，并向对方提供掌握的所有相关情况。
      </p>
      <p>5.保密资料安全保护要求</p>
      <p>
        5.1本协议任何一方均应对所获得的另一方的保密资料实施必要的安全保护措施，保护措施应当至少涵盖以下要求：
      </p>
      <p>
        （1）对于保密资料的访问应当充分做好访问控制（包括技术层面、物理层面），仅限于授权的相关人员或者相关应用进行访问。
      </p>
      <p>
        （2）禁止在第三方信息平台（如网盘、网站、博客等提供信息存储的平台）公开存储或处理对方的保密资料。
      </p>
      <p>
        （3）应当确保用于存储保密资料的技术平台安全性（包括网站、应用系统、操作系统、服务器、数据库等）。
      </p>
      <p>
        （4）应当对指定保密信息（如用户信息等）的传输和存储实施满足国家及监管要求的加密安全措施。
      </p>
      <p>
        5.2本协议任何一方如发现对方存在涉及保密资料保护措施缺失、数据滥用、严重泄露等问题，发现方有权按照本协议相关条款进行处理，并且对于已产生的实际损失和不良影响，由对方全责承担。
      </p>
      <p>5.3本保密条款不因本协议的解除、变更、终止而失效。</p>
      <p>八、知识产权</p>
      <p>
        1.甲乙双方根据本协议提供的产品及其相关服务的著作权、专利权等全部知识产权及所有权均归各自或相关权利人所有，并不因本协议的履行而发生改变。
      </p>
      <p>
        2.本协议的签订不涉及任何一方的任何技术、产品、服务、数据等的著作权、专利权等任何知识产权、所有权、名称或利益的转让，该等知识产权、所有权、名称或利益仍归原所有权人所有。
      </p>
      <p>
        3.本协议执行期内，本协议一方获得另一方的授权，可基于履行本协议的目的使用另一方的商标、标识等产品或服务标志以及企业名称、标识，但应当保证该等使用仅限用于本协议下的合作事项，不夹带任何与本协议目的无关的内容，且不超出本协议约定的使用范围和授权期限；同时，该种使用也不应使任何第三方产生诸如另一方为对方的分支机构、关联方或合伙人之类或有其他超出本协议规定之合作关系的误解。如本协议终止，上述授权自动终止。
      </p>
      <p>
        4.任何一方因使用对方的知识产权、品牌、相关信息进行宣传推广而侵犯任何第三方的合法权益，从而导致被采取行动或索赔，所有方应承诺积极消除上述影响，进行公开的事实澄清，承担因此造成的责任，并赔偿对方由此而造成的全部损失。
      </p>
      <p>
        5.任何一方不得擅自复制、再造或制造与对方商号、商标、标识、产品或服务名称、公司名称、LOGO等知识产权、品牌及相关信息有关的派生产品。若未遵守本条内容，致使对方遭受相关经济损失和/或名誉损害的，违约方应积极消除上述影响，进行公开的事实澄清，并赔偿守约方因此产生的相应损失。
      </p>
      <p>九、免责条款</p>
      <p>
        1.任何一方因其无法预见或虽能预见但无法避免的原因，包括但不限于战争、火灾、封锁、罢工、黑客攻击、电脑病毒、运营商服务中断或自然灾害而导致其无法履行协议项下的义务时，该方对另一方因上述不履行而导致的损失或损害不承担责任。任何一方在知道可能导致不可抗力的事件发生时应立即通知另一方。
      </p>
      <p>
        2.因协议主要条款受不可抗力影响，而使协议无法履行时，双方协商一致后以书面的形式解除本协议，双方应当据实结算协议解除前已发生的款项，双方承担各自损失。
      </p>
      <p>
        3.协议执行过程遇有国家政策性调整，按调整后的国家有关政策执行。本协议若与国家法律法规相抵触时，应以国家法律法规为准。
      </p>
      <p>十、反商业贿赂条款</p>
      <p>
        1.双方都清楚并愿意严格遵守中华人民共和国反商业贿赂的法律规定，双方都清楚任何形式的贿赂和贪渎行为都将触犯法律，并将受到法律的严惩。
      </p>
      <p>
        2.任何一方均不得向对方或对方经办人或其他协议相关人员索要、收受、提供、给予协议约定外的任何利益，包括但不限于明扣、暗扣、现金、购物卡、实物、有价证券、旅游或其他非物质性利益等，但如该等利益属于行业惯例或通常做法，则须在协议中明示。
      </p>
      <p>
        3.双方严格禁止双方经办人员的任何商业贿赂行为。双方经办人或者其他任何人发生本条第二款所列示的任何一种行为，都是违反双方公司制度以及相关法律法规规定的，都将受到双方公司制度和国家法律的惩处。
      </p>
      <p>
        4.双方郑重声明：双方均反对对方或对方经办人员为了本协议之目的与本协议以外的任何第三方发生本条款第二条所列示的任何一种行为，该等行为都是违反国家法律的行为，并将受到国家法律的惩处。
      </p>
      <p>
        5.如因一方或一方经办人违反上述第二条、第三条、第四条之规定，给对方造成损失的，应承担损害赔偿责任，赔偿金额最低为任何一方受贿金额的十倍最高以一方受到的实际损失为限。
      </p>
      <p>
        6.本条所称“其他相关人员”是指协议经办人以外的与协议有直接或间接利益关系的人员，包括但不仅限于协议经办人的亲友。
      </p>
      <p>
        7.如发现对方或者己方协议有关人员存在商业贿赂的，均可向己方以及对方公司举报，乙方反商业贿赂举报邮箱：lion@eqlee.com。
      </p>
      <p>
        8.受理举报的一方或者双方，必须就收到的举报进行调查并将结果互相向对方公示。
      </p>
      <p>十一、其他</p>
      <p>
        1.本协议未尽事宜以双方签订的““WoYou工资”企业服务协议”为准。本协议以及与本协议有关的任何事项的订立、效力、解释、履行及争议均适用中华人民共和国法律。您和“WoYou工资”企业服务一致同意服从法院的管辖。
      </p>
      <p>
        2.在协议执行期内，凡由本协议引起的或与本协议有关的一切争议及纠纷，甲乙双方应首先友好协商解决。协商不成的，应提交本协议签署地即广东省珠海市人民法院通过诉讼的方式解决。
      </p>
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      enterpriseServiceVisible: false,
    };
  },
  methods: {
    enterpriseServiceVisibleClose() {
      this.$emit("close");
    },
  },
  watch: {
    visible(val) {
      this.enterpriseServiceVisible = val;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 25px;
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>